<template>
  <div class="col-12 col-lg-4 col-xl-3 border-right">

    <div class="d-block d-lg-none">
      <a
        href="#"
        class="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
        v-if="selectedRecipient"
        @click.prevent="showRecipients = ! showRecipients"
      >
        <div class="d-flex align-items-center">
          <img :src="selectedRecipient.profile_image" class="rounded-circle mr-1" :alt="selectedRecipient.first_name" width="40" height="40" />
          <div class="flex-grow-1 ml-3">
            {{ selectedRecipient.first_name }} {{ selectedRecipient.last_name }}
          </div>
        </div>
        <i class="fas fa-chevron-down"></i>
      </a>
    </div>

    <div v-show="showRecipients || !selectedRecipient" class="users-box">
      <recipient
        :recipients="conversations"
        :activeRecipient="selectedRecipient"
        title="Messages"
      ></recipient>
    </div>

    <hr class="d-block d-lg-none mt-1 mb-0" />
  </div>
</template>

<script>
import Recipient from "@/components/Chatbox/Recipient";
export default {
  components: {Recipient},
  props: {
    conversations: Array,
    selectedRecipient: Object
  },
  watch:{
    $route() {
      if (window.innerWidth <= 992) {
        this.showRecipients = false;
      }
    }
  },
  created() {
    this.toggleShowCoachesList()
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.toggleShowCoachesList()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.toggleShowCoachesList()
    })
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
  },
  data() {
    return {
      showRecipients: null,
    }
  },
  methods: {
    toggleShowCoachesList() {
      this.showRecipients = window.innerWidth > 992
    },
  }
}
</script>

<style scoped>

.list-group-item.selected {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.users-box {
  max-height: calc(100vh - 135px);
  /*max-height: calc(100vh - 200px);*/
  overflow-y: auto;
  overflow-x: hidden;
}

</style>
